export default {
  theme1: {
    primaryColor: "#165F85",
    secondaryColor: "#EEF9FF",
    userImg: require("../../src/assets/images/users/avatar-1.jpg"),
  },
}
